import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=b69fb068&scoped=true&"
import script from "./sendEmail.vue?vue&type=script&lang=js&"
export * from "./sendEmail.vue?vue&type=script&lang=js&"
import style0 from "./sendEmail.vue?vue&type=style&index=0&id=b69fb068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69fb068",
  null
  
)

component.options.__file = "sendEmail.vue"
export default component.exports